var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"row",attrs:{"id":"nav"}},[_c('Updates'),_c('Profile'),_c('Header'),_c('Register'),_c('Contact')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }